import { render, staticRenderFns } from "./BulkImportHistory.vue?vue&type=template&id=fb3dc116"
import script from "./BulkImportHistory.vue?vue&type=script&lang=js"
export * from "./BulkImportHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports